<div id="contract-accessories" class="card">
    <div class="card-body">
        <form [formGroup]="form">
            <ng-container formArrayName="accessories">
                <datalist id="accessory-vendors">
                    @for (vendor of vendors; track vendor) {
                        <option value="{{vendor.name}}" data-id="{{vendor.id}}">{{vendor.name}}</option>
                    }
                </datalist>

                <ul>
                    <li class="header">
                        <p class="text-left">Name</p>
                        <p class="text-left">Vendor</p>
                        <p class="text-right">Cost</p>
                        <p class="text-right">Price</p>
                        <p></p>
                    </li>
                    @for (accForm of accessories.controls; track accForm; let i = $index) {
                        <li [formGroup]="accForm">
                            @if (!accForm.get('accessoryId').value) {
                                <input type="search" class="form-control form-control-sm" formControlName="accessory" placeholder="Name" />
                            }
                            @if (accForm.get('accessoryId').value > 0) {
                                <span class="form-text">{{accForm.get('accessory').value}}</span>
                            }
                            @if (((!accForm.get('accessoryId').value) || (!accForm.get('contactId').value))) {
                                <input type="search" class="form-control form-control-sm" formControlName="vendor" placeholder="Vendor" list="accessory-vendors" (blur)="vendorChanged($event, i)" (change)="vendorChanged($event, i)" />
                            }
                            @if (((accForm.get('accessoryId').value > 0) && (accForm.get('contactId').value > 0))) {
                                <span class="form-text text-truncate"><abbr [title]="accForm.get('vendor').value">{{accForm.get('vendor').value}}</abbr></span>
                            }
                            <currency-input [id]="'acc-cost' + i" [control]="accForm.get('cost')"></currency-input>
                            <currency-input [id]="'acc-price' + i" [control]="accForm.get('price')"></currency-input>
                            <div class="actions">
                                <button type="button" title="Delete" class="btn btn-sm btn-link" (click)="discard($event, i)" [disabled]="!isUnLock"><span class="dripicons dripicons-trash text-danger"></span></button>
                                @if (isUnLock && accForm.valid && accForm.dirty) {
                                    <button type="button" title="Save" class="btn btn-sm btn-link" (click)="save($event, i)"><span class="dripicons dripicons-cloud-upload text-primary"></span></button>
                                }
                            </div>
                        </li>
                    }
                    @if (accessories.controls.length > 0) {
                        <li class="totals">
                            <p class="text-left"></p>
                            <p class="text-left"></p>
                            <p class="text-right">{{cost | currency}}</p>
                            <p class="text-right">{{total | currency}}</p>
                            <p></p>
                        </li>
                    }
                </ul>
            </ng-container>
        </form>
        <div class="button-bar text-right">
            @if (accessories.valid && accessories.dirty) {
            <button type="button" class="btn btn-primary btn-sm" (click)="saveAll()" id="saveAllAccessories">
                @if (saving) {
                    <span class="spinner-grow spinner-grow-sm" role="status"></span>
                }
                @if (!saving) {
                    <span class="dripicons dripicons-cloud-upload"></span>
                }
                Save All
            </button>
            }
            @if (!corpAccessories || (corpAccessories.length <= 0)) {
                <button type="button" class="btn btn-success btn-sm" (click)="add($event)" id="addAccessory" [disabled]="!isUnLock"><span class="dripicons dripicons-plus"></span></button>
            }
            @if (corpAccessories && (corpAccessories.length > 0)) {
                <div class="dropdown">
                    <button type="button" class="btn btn-success btn-sm dropdown-toggle" id="addAccessoryMenu" data-toggle="dropdown" aria-expanded="false" [disabled]="!isUnLock">
                        <span class="dripicons dripicons-plus"></span>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item default" href="#" (click)="add($event)">New accessory</a>
                        <div class="dropdown-divider"></div>
                        @if (((!availableAccessories) || (availableAccessories.length == 0))) {
                            <a class="dropdown-item disabled">No more accessories available.</a>
                        }
                        @for (acc of availableAccessories; track acc) {
                            <a class="dropdown-item" href="#" (click)="add($event, acc)">
                                {{acc.name}}
                                @if (acc.contact) {
                                    <p class="subtitle">{{acc.contact.name}}</p>
                                }
                            </a>
                        }
                    </div>
            </div>
            }
        </div>
    </div>
</div>